"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DevUtil {
    /**
     * Helpful during development
     * Used to log instances of classes that have unexpected behaviour, used for debugging
     * assign this method to convert the instance of the class into a proxy that logs all method calls
     * @param target The class you want to observe
     * @param relevantProperties properties/functions that are interesting to listen to
     */
    static proxyLog(target, relevantProperties) {
        return new Proxy(target, {
            get(instance, property) {
                const prop = instance[property];
                if (typeof prop === "function") {
                    return function () {
                        if (!relevantProperties || relevantProperties.includes(property)) {
                            console.trace(instance, property, arguments);
                        }
                        // here you can still invoke the original method, of course
                        // @ts-ignore
                        return target[property].apply(this, arguments);
                    };
                }
                if (!relevantProperties || relevantProperties.includes(property)) {
                    console.trace(instance, property);
                }
                return instance[property];
            },
            set: function (instance, property, value) {
                if (!relevantProperties || relevantProperties.includes(property)) {
                    console.trace(instance, property, value);
                }
                instance[property] = value;
                // Indicate success
                return true;
            }
        });
    }
}
exports.default = DevUtil;
//# sourceMappingURL=DevUtil.js.map